export default "__VITE_ASSET__CNEbJCLw__"